import { render, staticRenderFns } from "./segment-link.vue?vue&type=template&id=73ee6e5e&"
import script from "./segment-link.vue?vue&type=script&lang=js&"
export * from "./segment-link.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports